import React, { useState } from "react";
import Navbar from "../../../components/layout/Navbar";
import SectionHeader from "../../../components/ui/HeaderSection";
import ThemesCard from "../../../components/ui/ThemesCard";

const ThemeDetail = () => {
  const [filter, setFilter] = useState("all");

  const themes = [
    { id: 1, type: "vip" },
    { id: 2, type: "basic" },
    { id: 3, type: "vip" },
    { id: 4, type: "premium" },
    { id: 5, type: "premium" },
    { id: 6, type: "premium" },
  ];

  const filteredThemes =
    filter === "all" ? themes : themes.filter((theme) => theme.type === filter);

  return (
    <>
      <Navbar />
      <div className="max-w-screen-lg mx-auto px-4 md:px-10 lg:px-0 py-10 mt-24 flex flex-col items-center text-center">
        <SectionHeader
          title="Berbagai Tema Menarik Menantimu"
          description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
          TitleColor="#010203"
          DescriptionColor="#ABABAB"
          textAlign="center"
        />

        <div className="flex flex-col items-start my-6 w-full">
          <span className="text-gray-600 font-montserrat text-lg mb-4">
            Menampilkan {filteredThemes.length} dari {themes.length} tema
          </span>
          <div className="flex space-x-2">
            {["all", "basic", "premium", "vip"].map((type) => (
              <button
                key={type}
                className={`px-4 py-1 mb-3 border rounded-full font-montserrat text-base transition-all 
                  ${
                    filter === type
                      ? "border-[#1B5E20] text-[#1B5E20]"
                      : "bg-[#F5F5F5] text-[#010203]"
                  } 
                `}
                onClick={() => setFilter(type)}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 min-h-[300px]"
          data-aos="fade-up"
        >
          {filteredThemes.map((theme) => (
            <ThemesCard
              key={theme.id}
              ribbonType={theme.type}
              data-aos="zoom-in"
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ThemeDetail;
